import Aos from "aos";
import React, { useEffect } from "react";

const About = () => {
  useEffect(() => {
    Aos.init({ once: true });

    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 100);
  });
  return (
    <div className="flex flex-col items-center mt-[40px] mb-[96px] gap-10 ">
      <div className=" flex justify-center self-stretch ">
        <div className="mx-auto flex w-full max-w-6xl self-end xl:px-0 px-5">
          <p
            className=" sm:text-[38px] md:text-[44px] text-[48px] font-medium text-black-900 "
            data-aos="fade-up"
            data-aos-duration="1000"
          >
            Modulárny systém
          </p>
        </div>
      </div>
      <div className="flex flex-col w-full">
        <div className="flex justify-center">
          <div className="mx-auto flex w-full max-w-6xl items-center justify-center gap-6 lg:flex-row flex-col xl:px-0 px-5">
            <div className="flex flex-col lg:w-[50%] w-full gap-4">
              <div className="" data-aos="fade-up" data-aos-duration="1000">
                <img src="assets/Images/emma1.jpg" className="w-full" alt="" />
              </div>
              <div className="flex flex-row gap-4">
                <div className="w-[50%]">
                  <img
                    src="assets/Images/emma2.jpg"
                    className="w-full h-full"
                    alt=""
                    data-aos="fade-up"
                    data-aos-duration="1000"
                  />
                </div>
                <div className="w-[50%]">
                  <img
                    src="assets/Images/emma3.jpg"
                    className="w-full h-full"
                    alt=""
                    data-aos="fade-up"
                    data-aos-duration="1000"
                  />
                </div>
              </div>
            </div>

            <div className="flex flex-col gap-2 lg:w-[50%] w-full">
              <h2
                className="mb-[15px] font-manrope text-[26px] font-semibold text-lime-500 relative inline p-[0] capitalize leading-[1]"
                data-aos="fade-up"
                data-aos-duration="1000"
                style={{ fontSize: "22px" }}
              >
                Kombinujte moduly,{" "}
                <span className="text-lime-900">vytvorte vlastný priestor</span>
              </h2>
              <p
                class="font-Poppins mb-[16px] text-[14px] text-gray-600 font-light leading-[28px] tracking-[0.03rem]"
                data-aos="fade-up"
                data-aos-duration="1000"
                style={{ textAlign: "justify" }}
              >
                Flexibilita je základnou vlastnosťou nášho modulárneho systému.
                Umožňuje vám jednoducho prispôsobiť usporiadanie sedacích súprav
                rôznym priestorom a individuálnym potrebám. Či už hľadáte
                kompaktné riešenie pre menší byt alebo rozľahlé usporiadanie pre
                veľký interiér, systém vám ponúka možnosť vytvoriť ideálnu
                konfiguráciu bez nutnosti kompromisov. Jednoduchá kombinácia a
                prepojenie modulov otvára nekonečné možnosti variácií, čo vám
                dáva slobodu experimentovať a neustále meniť vzhľad a funkčnosť
                vášho priestoru.
              </p>

              <p
                class="font-Poppins mb-[16px] text-[14px] text-gray-600 font-light leading-[28px] tracking-[0.03rem]"
                data-aos="fade-up"
                data-aos-duration="1000"
                style={{ textAlign: "justify" }}
              >
                Tento systém spája estetiku s komfortom, čo zaručuje nielen
                vynikajúci vzhľad, ale aj dlhodobú spoľahlivosť a odolnosť voči
                každodennému používaniu.
              </p>

              <div className="flex flex-wrap w-full mb-[-24px]">
                <div className="sm:w-[33.33%] w-full px-[12px] mb-[24px] ">
                  <div
                    className="flex flex-col p-[20px] bg-[#f8f8fb] border-[1px] border-solid border-[#eee] rounded-[20px]"
                    data-aos="fade-up"
                    data-aos-duration="1000"
                  >
                    <div style={{ height: "78px" }}>
                      <img
                        src="assets/Images/01.png"
                        style={{
                          marginBottom: "5px",
                          width: "60px",
                          marginLeft: "auto",
                          marginRight: "auto",
                        }}
                      />
                    </div>
                    <p
                      className="font-light tracking-[0.03rem] text-[14px] leading-[18px] text-[#686e7d] mb-[0] text-center"
                      style={{ fontWeight: "bold", color: "red" }}
                    >
                      <p
                        style={{
                          textDecoration: "line-through",
                          color: "rgb(119, 124, 132)",
                          fontWeight: "normal",
                        }}
                      >
                        2.054
                      </p>
                      €1.582€
                    </p>
                  </div>
                </div>
                <div className="sm:w-[33.33%] w-full px-[12px] mb-[24px] ">
                  <div
                    className="flex flex-col p-[20px] bg-[#f8f8fb] border-[1px] border-solid border-[#eee] rounded-[20px]"
                    data-aos="fade-up"
                    data-aos-duration="1000"
                  >
                    <div style={{ height: "78px" }}>
                      <img
                        src="assets/Images/02.png"
                        style={{
                          marginBottom: "5px",
                          width: "80px",
                          marginLeft: "auto",
                          marginRight: "auto",
                        }}
                      />
                    </div>
                    <p
                      className="font-light tracking-[0.03rem] text-[14px] leading-[18px] text-[#686e7d] mb-[0] text-center"
                      style={{ fontWeight: "bold", color: "red" }}
                    >
                      <p
                        style={{
                          textDecoration: "line-through",
                          color: "rgb(119, 124, 132)",
                          fontWeight: "normal",
                        }}
                      >
                        2.834
                      </p>
                      €2.182€
                    </p>
                  </div>
                </div>
                <div className="sm:w-[33.33%] w-full px-[12px] mb-[24px] ">
                  <div
                    className="flex flex-col p-[20px] bg-[#f8f8fb] border-[1px] border-solid border-[#eee] rounded-[20px]"
                    data-aos="fade-up"
                    data-aos-duration="1000"
                  >
                    <div style={{ height: "78px" }}>
                      <img
                        src="assets/Images/03.png"
                        style={{
                          marginBottom: "5px",
                          width: "80px",
                          marginLeft: "auto",
                          marginRight: "auto",
                        }}
                      />
                    </div>
                    <p
                      className="font-light tracking-[0.03rem] text-[14px] leading-[18px] text-[#686e7d] mb-[0] text-center"
                      style={{ fontWeight: "bold", color: "red" }}
                    >
                      <p
                        style={{
                          textDecoration: "line-through",
                          color: "rgb(119, 124, 132)",
                          fontWeight: "normal",
                        }}
                      >
                        3.883€
                      </p>
                      2.990€
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
